import { Route, Routes } from "react-router-dom"
import FrontRoutes from "./FrontRoutes"
import AdminRoutes from "./AdminRoutes"
import PartnerRoutes from "./PartnerRoutes"
import DemoRoutes from "./DemoRoutes"
import OnboardingPartnerRoutes from "./OnboardingPartnerRoutes"

const AppRoutes = () => {
    return (
        <Routes>
            {/* Marketing Website */}
            <Route path="/*" element={<FrontRoutes />} />

            {/* Admin Panel */}
            <Route path="/admin/*" element={<AdminRoutes />} />

            { /** Stepper form */}
            <Route path="/onboarding/*" element={<OnboardingPartnerRoutes />} />
            
            {/* End User Panel */}
            <Route path="/partner/*" element={<PartnerRoutes />} />

            {/* Demo Panel */}
            <Route path="/demo/*" element={<DemoRoutes />} />

            
        </Routes>
    )
}

export default AppRoutes;